import { convertKpiToBadgeColor } from "@/containers/Project/components/ProjectHeader/helpers/convertKpiToBadgeColor";
import { useIntl } from "react-intl";
import { StatusBadgeRow } from "../styled";
import { StatusBadge } from "./StatusBadge";

interface IProps {
  statusKpis: Record<string, string>;
}

export const ProjectStatusBadges = ({ statusKpis }: IProps) => {
  const intl = useIntl();

  return (
    <StatusBadgeRow justify="center">
      {Object.keys(statusKpis).length &&
        Object.keys(statusKpis).map((kpi) => (
          <StatusBadge
            key={kpi}
            status={convertKpiToBadgeColor(statusKpis[kpi])}
            label={intl.formatMessage({
              id: `kpiLabels.${kpi.toLocaleLowerCase()}`,
            })}
          />
        ))}
    </StatusBadgeRow>
  );
};
